"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubDocumentCollection = void 0;
var tslib_1 = require("tslib");
var parameter_checker_1 = require("../../api-utils/api-utils/parameter-checker");
var number_1 = require("@devexpress/utils/lib/utils/map/number");
var sub_document_1 = require("../sub-document");
var collection_1 = require("./collection");
var SubDocumentCollection = (function (_super) {
    tslib_1.__extends(SubDocumentCollection, _super);
    function SubDocumentCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SubDocumentCollection.prototype, "main", {
        get: function () {
            return this._getItem(this._processor.modelManager.model.mainSubDocument);
        },
        enumerable: false,
        configurable: true
    });
    SubDocumentCollection.prototype.getById = function (id) {
        return this._getItem(this._processor.modelManager.model.subDocuments[id]);
    };
    SubDocumentCollection.prototype.forEach = function (callback) {
        var _this = this;
        callback = parameter_checker_1.ApiParametersChecker.check(callback, 1, true, [
            parameter_checker_1.ApiParametersChecker.functionDescriptor('callback', function (val) { return val; })
        ]);
        number_1.NumberMapUtils.forEach(this._processor.modelManager.model.subDocuments, function (subDoc) { return callback(_this._getItem(subDoc)); });
    };
    SubDocumentCollection.prototype._getItem = function (coreItem) {
        return new sub_document_1.SubDocumentApi(this._processor, coreItem);
    };
    SubDocumentCollection.prototype._getCoreItems = function () {
        return number_1.NumberMapUtils.toList(this._processor.modelManager.model.subDocuments);
    };
    return SubDocumentCollection;
}(collection_1.Collection));
exports.SubDocumentCollection = SubDocumentCollection;
